import { useQuery, useMutation } from "@tanstack/react-query";
import { Simulation } from "../../interfaces/DTO/simulation";
import { simulationService } from "../../services/SimulationService";
import { createCachedEntityHooks } from "../createEntityHooks";

// ✅ hook-ים גנריים עם cache לפי id בלבד
export const {
  useAll: useSimulations,
  useEntityById: useSimulationById,
  useEntityByIds: useSimulationByIds,
  useCreateEntity: useCreateSimulation,
  useUpdateEntity: useUpdateSimulation,
  usePartialUpdateEntity: usePartialUpdateSimulation,
  useDeleteEntity: useDeleteSimulation,
} = createCachedEntityHooks<Simulation>({
  entityName: "simulations",
  service: simulationService,
  enableCacheById: true,
  staleTimeMs: 5000,
});

// ✅ שליפה לפי כמה contact_ids (עם period אופציונלי)
export function useSimulationsByContactIds(contactIds: number[], reportedPeriod?: string) {
  return useQuery<Simulation[]>({
    queryKey: ["simulations-by-users", { contactIds, reportedPeriod }],
    queryFn: async () => {
      return simulationService.fetchByContactsAndPeriod(contactIds, reportedPeriod);
    },
    enabled: contactIds.length > 0,
    staleTime: 10000,
  });
}

// ✅ יצירה מהירה (quick-create)
export function useQuickCreateSimulation() {
  return useMutation({
    mutationFn: simulationService.quickCreate.bind(simulationService),
  });
}

// ✅ יצירה עם snapshot
export function useCreateSimulationWithSnapshot() {
  return useMutation({
    mutationFn: simulationService.createWithSnapshot.bind(simulationService),
  });
}
